import { useState, useCallback } from 'react';

export type ViewMode = 'card' | 'compact' | 'list';

const STORAGE_KEY = 'bookmark_view_mode';
const VALID_MODES: ViewMode[] = ['card', 'compact', 'list'];

function readStoredMode(): ViewMode {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && VALID_MODES.includes(stored as ViewMode)) {
      return stored as ViewMode;
    }
  } catch {
    // localStorage unavailable
  }
  return 'card';
}

function persistMode(mode: ViewMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // Quota exceeded or unavailable — continue without persistence
  }
}

export interface UseViewModeReturn {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}

export function useViewMode(): UseViewModeReturn {
  const [viewMode, setViewModeState] = useState<ViewMode>(readStoredMode);

  const setViewMode = useCallback((mode: ViewMode) => {
    setViewModeState(mode);
    persistMode(mode);
  }, []);

  return { viewMode, setViewMode };
}
